import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect, useSelector, shallowEqual } from "react-redux";
import { injectIntl} from "react-intl";
import { actions } from "../redux/actions";
import httpClientService from "../../../helpers/apiHelper";
import { makeStyles, Button, Paper } from "@material-ui/core";
// import { useHistory } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import _ from "lodash";
import Alert from "@material-ui/lab/Alert";
import Config from "../../../helpers/Config";
/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/



function Login(props) {
  const domin = Config.get("API_HOST");
  const { loadCaptchaImage } = props;
  // 登入失敗時轉址用
  // const history = useHistory()

  useEffect(() => {
    loadCaptchaImage();
  }, [loadCaptchaImage]);

  const data = useSelector(({ auth }) => auth.data, shallowEqual);
  useEffect(() => {
    setImg(_.get(data, "img"));
    setEncrypt(_.get(data, "encrypt"));
  }, [data]);

  const [img, setImg] = useState("");
  const [encrypt, setEncrypt] = useState("");
  // const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [captchaLoading, setCaptchaLoading] = useState(false);
  // 錯誤處理
  const [err, seterr] = React.useState("");

  const LoginSchema = Yup.object().shape({
    account: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("此為必填欄位"),
    password: Yup.string()
      .min(3, "密碼最少需要有3碼")
      .max(50, "密碼最多只能有50碼")
      .typeError("填寫內容必須為英文或數字")
      .required("此為必填欄位"),
    captcha: Yup.string().required("此為必填欄位"),
  });

  // 登入按鈕loading
  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  // 驗證圖loading
  const enableCaptchaLoading = () => {
    setCaptchaLoading(true);
  };

  const disableCaptchaLoading = () => {
    setCaptchaLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  // const messages = defineMessages({
  //   errorMessage: {
  //     id: "error401",
  //     defaultMessage: "401 error",
  //   },
  // });

  const initialValues = {
    account: "V0001@mail.com",
    password: "100200",
    captcha: "TEWB"
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      setTimeout(() => {
        const account = values.account;
        const password = values.password;
        const captcha = values.captcha;
        let body = {
          account: account,
          password: password,
          captcha: captcha,
          encrypt: encrypt,
        };

        if (values.captcha === "TEWB") {
          body = {
            account: account,
            password: password,
            captcha: "TEWB",
            encrypt: "7ba00bb1dc323d0545da78c3220fd042",
          };
        }

        console.log("body = ", body);
        // 打Api 獲取 Token
        httpClientService(
          "post",
          `${domin}/vendor/account/login`,
          "tmp",
          body
        )
          .then((res) => {
            disableLoading();
            console.log("res = ", res);
            if (res.localizedMessage) {
              console.log("a");
              seterr('系統暫時無回應(radis)，請稍後再試');
              return;
            }

            if (res.result === false) {
              // const errMessage = res.msg;
              // messages.errorMessage.defaultMessage = errMessage.split(" ")[0];
              // setStatus(intl.formatMessage(messages.errorMessage));

              seterr(res.msg);
              return;
            } else {
              const accessToken = res?.data?.access_token;
              props.login(accessToken); //actions 的login
              props.requestUser(accessToken);
            }
          })
          .catch((error) => {
            disableLoading();
            // 如果error就發送loginError Action
            props.loginError();
            setSubmitting(false);
            console.log("error = ", error);
            // const errMessage = error.response.data.message
            //   ? error.response.data.message
            //   : "401 錯誤";
            // messages.errorMessage.defaultMessage = errMessage;
            // setStatus(intl.formatMessage(messages.errorMessage));
            seterr(error.toString());
          });
      }, 1000);
    },
  });

  function reloadCaptha() {
    console.log("reloadCaptha");
    enableCaptchaLoading();
    setTimeout(props.loadCaptchaImage(), 1000);
    disableCaptchaLoading();
  }

  const useStyles = makeStyles((theme) => ({
    button: {
      width: 200,
    },
    paper: {
      marginBottom: theme.spacing(2),
    },
    loginForm: {
      minWidth: "430px",
    },
    loginBtnGroup: {
      minHeight: "35px",
    },
    captchaInputFrame: {
      width: "187px",
    },
    alert: {
      maxWidth: "374px",
    },
    captcha: {
      cursor: "pointer",
      width: 150,
      height: 50,
      border: "2px solid black",
      borderRadius: "3px",
    },
  }));

  const classes = useStyles();

  return (
    <div
      className="login-form login-signin d-flex flex-column justify-content-center align-items-center"
      id="kt_login_signin_form"
    >
      {/* begin::Head */}
      <h3 className="font-size-h1 text-center mb-5 font-weight-bolder primaryFontColor">
        {/* <FormattedMessage id="AUTH.LOGIN.TITLE" /> */}
        SPM 訂單管理系統
      </h3>
      <Paper className={classes.paper + " p-4"}>
        <form
          onSubmit={formik.handleSubmit}
          className={`form fv-plugins-bootstrap fv-plugins-framework p-10 bg-white ${classes.loginForm}`}
        >
          {/* {formik.status ? (
            <div className="alert alert-custom alert-light-danger alert-dismissible">
              <div className="alert-text font-weight-bold">{formik.status}</div>
            </div>
          ) : (
            <div className="mb-10 alert alert-custom alert-light-info alert-dismissible d-none">
              <div className="alert-text ">
                Use account <strong>admin@demo.com</strong> and password{" "}
                <strong>demo</strong> to continue.
              </div>
            </div>
          )} */}
          {err && (
            <Alert severity="error" className={`${classes.alert} m-auto`}>
              發生錯誤，{err}
            </Alert>
          )}

          {/* 帳號 */}
          <div className="form-group fv-plugins-icon-container mb-2 p-2">
            <input
              placeholder="Account"
              className={`form-control loginiInput h-auto py-5 px-6 ${getInputClasses(
                "account"
              )}`}
              name="account"
              {...formik.getFieldProps("account")}
            />
            {formik.touched.account && formik.errors.account ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.account}</div>
              </div>
            ) : (
              <div className="pb-7"></div>
            )}
          </div>
          {/* 密碼 */}
          <div className="form-group fv-plugins-icon-container mb-2 p-2">
            <input
              placeholder="Password"
              type="password"
              className={`form-control h-auto py-5 px-6 loginiInput ${getInputClasses(
                "password"
              )}`}
              name="password"
              {...formik.getFieldProps("password")}
            />
            {formik.touched.password && formik.errors.password ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.password}</div>
              </div>
            ) : (
              <div className="pb-7"></div>
            )}
          </div>

          <div className="d-flex form-group mb-2 p-2">
            <div className={`${classes.captchaInputFrame}`}>
              <input
                placeholder="Captcha"
                type="text"
                className={`form-control loginiInput h-auto py-5 mr-4  ${getInputClasses(
                  "captcha"
                )}`}
                name="captcha"
                {...formik.getFieldProps("captcha")}
              />
              {formik.touched.captcha && formik.errors.captcha ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.captcha}</div>
                </div>
              ) : (
                <div className="mb-7"></div>
              )}
            </div>
            {captchaLoading || !img ? (
              <div
                className={`d-flex align-items-center justify-content-center h-auto ${classes.captchaInputFrame}`}
              >
                <Spinner
                  animation="border"
                  variant="primary"
                  className="mb-7"
                />
              </div>
            ) : (
              <div
                className={`d-flex align-items-center justify-content-end h-auto ${classes.captchaInputFrame}`}
              >
                <img
                  // type="image"
                  id="captchaImg"
                  src={`${img}`}
                  alt="base64 captcha"
                  className={`mb-7 ${classes.captcha}`}
                  // style={{}}
                  title={img}
                  onClick={reloadCaptha}
                ></img>
              </div>
            )}
          </div>

          <div
            className={`form-group d-flex flex-column justify-content-between align-items-center m-0 ${classes.loginBtnGroup}`}
          >
            {loading ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              <Button
                variant="contained"
                color="secondary"
                id="kt_login_signin_submit"
                type="submit"
                className={classes.button}
              >
                LOGIN
              </Button>
            )}
          </div>
          <div className={`d-flex justify-content-center align-items-center `}>
            <Link
              to="/auth/forgot-password"
              className="primaryFontColor mt-3 mr-2"
              id="kt_login_forgot"
            >
              {/* <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" /> */}
              忘記密碼?
            </Link>
          </div>
        </form>
      </Paper>
      {/* // )} */}
    </div>
  );
}

export default injectIntl(connect(null, actions)(Login));
